import React, { useRef } from 'react';
import './Homeportfolio.css';
import Fikaa from '../../../Assets/Images/Fikka.webp';
import MissionToCure from '../../../Assets/Images/MissionToCure.webp';
import Oren from '../../../Assets/Images/Oren.png';
import Jags from '../../../Assets/Images/Jags.png';
import Idesign from '../../../Assets/Images/PortfolioImages/IdesignHomeBanner.png'
import SFsbannerimage from '../../../Assets/Images/SfsHomebanner.webp'
import MobileIdLABS from '../../../Assets/Images/PortfolioImages/MID-1.png'
import Gliding from '../../../Assets/Images/PortfolioImages/GlidinHomeBanner.png'
import GreatPlaceToWork from '../../../Assets/Images/New folder/1.webp'
import Goodrej from '../../../Assets/Images/PortfolioImages/2.webp'
import AsianPaints from '../../../Assets/Images/PortfolioImages/3.webp'



import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper/core';
import 'swiper/swiper-bundle.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Button } from '@mui/material';


// Import Swiper styles
import 'swiper/css/navigation';

// Import Navigation module separately
import { Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';

// Initialize Swiper core
SwiperCore.use([Navigation]);

function Homeportfolio() {
  const swiperRef = useRef(null);

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <div className='Homeportfolio-crousel'>
      <div className='portfolio-heading' >
        <h1>Portfolio</h1>
      </div>
      <div className='swiper-main' >
        <Swiper
          ref={swiperRef}
          spaceBetween={50}
          slidesPerView={2.4}
          loop={true} // Enable infinite loop
          navigation={{
            nextEl: '.custom-next-button',
            prevEl: '.custom-prev-button',
          }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log('slide change')}
        >
         <SwiperSlide className='swiper-slide-section' >
          <Link to="https://www.asianpaints.com/" style={{textDecoration:"none",color:"black"}} >
          <img src={AsianPaints} alt="Portfolio Case Study: Asian Paints Mobile App UI Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Asian Paints</p>
          </Link>
           
            
          </SwiperSlide>
        
          <SwiperSlide className='swiper-slide-section' >
          <Link to="https://www.greatplacetowork.in/for-all-community" style={{textDecoration:"none",color:"black"}} >
          <img src={GreatPlaceToWork} alt="Portfolio Case Study: Great Place To Work Web Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Great Place To Work</p>
          </Link>
      
          </SwiperSlide>


          <SwiperSlide className='swiper-slide-section' >
          <Link to="https://www.godrej.com/" style={{textDecoration:"none",color:"black"}} >
          <img src={Goodrej} alt="Portfolio Case Study: Godrej Locks Digital Experience" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Godrej Locks</p>
          </Link>
           

          </SwiperSlide>

          <SwiperSlide className='swiper-slide-section' >
          <Link to="/fikaacasestudy" style={{textDecoration:"none",color:"black"}} >
          <img src={Fikaa} alt="Portfolio Case Study: FIKAA Financial App UI Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>FIKAA - BE FINANCIALLY FREE</p>
          </Link>
           
            
          </SwiperSlide>
          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/missiontocurecasestudy" style={{textDecoration:"none",color:"black"}} >
          <img src={MissionToCure} alt="Portfolio Case Study: Mission to Cure Healthcare UI Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Mission to Cure</p>
          </Link>
         
           
          </SwiperSlide>
          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/Jagscasestudy" style={{textDecoration:"none",color:"black"}} >
          <img src={Jags} alt="Portfolio Case Study: Jags E-commerce Platform Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Jags</p>
          </Link>
            
           
          </SwiperSlide>
          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/iDesignCasestudy" style={{textDecoration:"none",color:"black"}} >
          <img src={Idesign} alt="Portfolio Case Study: Idesign Professional Portfolio Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Idesign</p>
          </Link>
            
            
          </SwiperSlide>
          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/sfscasestudies" style={{textDecoration:"none",color:"black"}} >
          <img src={SFsbannerimage} alt="Portfolio Case Study: Surgeons For Surgeons Platform UI" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Surgeons For Surgeons</p>
            
          </Link>
           
          </SwiperSlide>

          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/mobileidlabscasestudy" style={{textDecoration:"none",color:"black"}} >
          <img src={MobileIdLABS} alt="Portfolio Case Study: Mobile ID Lab Technology UI Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Mobile ID Lab</p>
          </Link>
          </SwiperSlide>

          <SwiperSlide className='swiper-slide-section'  >
          <Link to="/glidincasestudies" style={{textDecoration:"none",color:"black"}} >
          <img src={Gliding} alt="Portfolio Case Study: Glidin Motion UI Design" style={{ width: "100%" }} />
            <p className='firstheading-portfolio'>Glidin</p>
          </Link>
          </SwiperSlide>



        </Swiper>
      </div>
      <div className="custom-navigation">
      <Link to="/portfolio"  className='AllProjects-Portfoliobtn' style={{textDecoration:"none"}}>
      <Button
      className='All-Projects-Btn'
            variant="outlined"
            sx={{
              border: '1.2px solid #181818',
              color: '#181818',
              width: '180px',
              fontWeight:"600",
              height: '42px',
              marginLeft:"6%",
              borderRadius: '50px',
              '&:hover': {
                backgroundColor: '#000',
                color:"#fff",
                border:"#fff" // Set the hover background color to transparent
              },
              '& .MuiSvgIcon-root': {
            fontSize: 20 // Adjust the size of the icon here
        }
              

            }}
          >
            All Projects <ArrowOutwardIcon />
          </Button>
      </Link>

      

    
      
        <button className="custom-prev-button portfolio-btn-btn" onClick={goPrev}>
          {/* Your custom previous button icon or content */}
          <ArrowBackIcon/>
        </button>
        <button className="custom-next-button" onClick={goNext}>
          {/* Your custom next button icon or content */}
         <ArrowForwardIcon/>
        </button>
      </div>
    </div>
  );
}

export default Homeportfolio;
